module.exports = __webpack_public_path__ + "static/logo-acff67decc4e048a03da1cf1567c9d36.svg";